const strings = {
  'challenges/season/title': {
    en: 'NHL® 2026/2027<br /> REGULAR SEASON<br /> CHALLENGE',
    fr: 'DÉFI DE LA SAISON<br /> RÉGULIÈRE 2026-2027<br /> DE LA LNH<sup>MD</sup>',
  },
  'challenges/season/heatstreak/title': {
    en: 'NHL® 2026/2027<br /> Regular Season<br /> Challenge',
    fr: 'Défi de la saison régulière 2026-2027 de la LNH<sup>MD</sup>',
  },
  'challenges/season/title/playnow': {
    en: 'NHL® 2026/2027<br /> REGULAR SEASON<br /> CHALLENGE',
    fr: 'DÉFI DE LA SAISON<br /> RÉGULIÈRE 2026-2027<br /> DE LA LNH<sup>MD</sup>',
  },
  'challenges/playoff/title': {
    en: 'Stanley Cup® <br /> Playoffs Challenge',
    fr: 'Défi des séries </br>éliminatoires de la </br>Coupe Stanley<sup>MC</sup>',
  },

  'challenges/playoffcomingsoon/title': {
    en: 'STANLEY CUP®<br /> PLAYOFFS EDITION',
    fr: 'SÉRIES ÉLIMINATOIRES DE<br /> LA COUPE STANLEY<sup>MC</sup> ',
  },

  'challenges/season/text': {
    en: '<span>NHL® 2026/2027 Regular<br/>Season Grand Prize</span>Make the right picks and earn points throughout the NHL® 2026/2027 Regular Season for the chance to win a Hyundai SANTA FE Hybrid!',
    fr: '<span>Grand prix de la saison régulière 2026-2027 de la LNH<sup>MD</sup></span>Faites les bons choix et accumulez des points pendant toute la saison régulière 2026-2027 de la LNH<sup>MD</sup> pour gagner une Hyundai SANTA FE Hybride!',
  },
  'challenges/season/streaks/text': {
    en: 'Make the right picks and earn streaks throughout the NHL® 2026/2027 Regular Season for the chance to win a Hyundai SANTA FE Hybrid!',
    fr: 'Faites les bons choix et réalisez des victoires consécutives pendant toute la saison régulière 2026-2027 de la LNH<sup>MD</sup> pour courir la chance de gagner un Hyundai SANTA FE Hybride!',
  },
  'challenges/season/prizes': {
    en: [
      'A Hyundai SANTA FE Hybrid + $1,000 Canadian Tire Gift Card',
      'Free Coffee for a Year + One $100 NHL® Shop Gift Card + $500 Canadian Tire Gift Card',
      'One $500 Tims Gift Card + One $100 NHL® Shop Gift Card + $300 Canadian Tire Gift Card',
      'One $250 Tims Gift Card + One $100 NHL® Shop Gift Card',
      'One $150 Tims Gift Card + One $100 NHL® Shop Gift Card',
    ],
    fr: [
      'un Hyundai SANTA FE Hybride + une carte-cadeau Canadian Tire de 1 000 $',
      'Café gratuit pendant un an + une carte-cadeau de 100 $ de la boutique de la LNH<sup>MD</sup> + une carte-cadeau Canadian Tire de 500 $',
      'Une carte-cadeau Tim de 500 $ + une carte-cadeau de 100 $ de la boutique de la LNH<sup>MD</sup> + une carte-cadeau Canadian Tire de 300 $',
      'Une carte-cadeau Tim Hortons® de 250 $ + une carte-cadeau de 100 $ de la boutique de la LNH<sup>MD</sup>',
      'Une carte-cadeau Tim Hortons® de 150 $ + une carte-cadeau de 100 $ de la boutique de la LNH<sup>MD</sup>',
    ],
  },

  'challenges/playoff/text': {
    en: '<span>Stanley Cup® Playoffs Challenge</span> Make the right picks and build streaks throughout the Stanley Cup® Playoffs to win great prizes—and compete for the $5,000 Grand Prize!',
    fr: '<span>Défi des séries éliminatoires de la Coupe Stanley<sup>MC</sup></span> Faites les bons choix et réalisez des victoires consécutives pendant les séries éliminatoires de la Coupe Stanley<sup>MC</sup> pour courir la chance de gagner le grand prix de 5 000 $!',
  },

  'challenges/playoffcomingsoon/text': {
    en: '<span>Stanley Cup® Playoffs Edition</span>Playoffs are coming and we’ve got new prizes! Winners are picked at the end of the Stanley Cup® Playoffs!',
    fr: '<span>Édition des séries éliminatoires de la Coupe Stanley<sup>MC</sup></span>Les séries éliminatoires commencent bientôt, et nous avons de nouveaux prix! Les gagnants seront déterminés à la fin des séries éliminatoires de la Coupe Stanley<sup>MC</sup>!',
  },

  'challenges/blurb/text/line/1': {
    en: 'The top 5 players in each challenge will win amazing prizes!</br> Be sure to see how you stack up against others on the leaderboard.',
    fr: 'Pour chacun des défis, de superbes prix seront remis aux 5 meilleurs participants! Ne manquez pas de vérifier où vous vous situez dans le classement.',
  },
  'challenges/blurb/text/line/playoffs': {
    en: 'The top 5 players in the Stanley Cup® Playoffs Challenge will win amazing prizes!</br> Be sure to see how you stack up against other players on the leaderboard.',
    fr: 'Les 5 meilleurs participants du Défi des séries éliminatoires de la Coupe Stanley<sup>MC</sup> remporteront des prix incroyables!</br> Ne manquez pas de vérifier où vous vous situez dans le classement.',
  },
  'challenges/blurb/text/line/2': {
    en: '',
    fr: '',
  },
  'challenges/challenge1/img/src': {
    en: 'img-challenge-1.png',
    fr: 'img-challenge-1.png',
  },
  'challenges/heatstreak/banner/img': {
    en: '2025_heatstreak_banner_img_en.png',
    fr: '2025_heatstreak_banner_img_fr.png',
  },
  'challenges/heatstreak/banner/text': {
    en: `Guessed correctly for 7 consecutive days? You’ll win a free donut for a week!*`,
    fr: `Vous avez fait les bons choix pendant 7 jours consécutifs? Vous gagnez un beigne gratuit pendant une semaine*!`,
  },
  'challenges/heatstreak/banner/title': {
    en: `WIN A FREE*\nDONUT FOR A WEEK!`,
    fr: `Gagnez un beigne GRATUIT*\npendant une semaine!`,
  },
  'challenges/monthly/title': {
    en: 'MONTHLY CHALLENGE',
    fr: 'DÉFI MENSUEL',
  },
  'challenges/monthly/heatstreak/title': {
    en: 'Monthly Challenge',
    fr: 'Défi Mensuel',
  },
  'challenges/inProgress/text': {
    en: 'IN PROGRESS',
    fr: 'EN COURS',
  },
  'challenges/completed/text': {
    en: 'COMPLETED',
    fr: 'TERMINÉ',
  },
  'challenges/grandprize/title': {
    en: 'Grand Prize Challenge',
    fr: 'Défi de la saison régulière de la LNHmd Saison régulière',
  },
  'challenges/dates': {
    en: ['Sept 29-Oct 31', 'Nov 1 - Nov 30', 'Dec 1 - Dec 31', 'Jan 1 - Jan 31', 'Feb 1 - Feb 28', 'Mar 1 - April 10'],
    fr: [
      '29 sept. – 31 oct.',
      '1 nov. – 30 nov.',
      '1 déc. – 31 déc.',
      '1<sup style="font-size: 0.8em">er</sup> janv. - 31 janv.',
      '1<sup style="font-size: 0.8em">er</sup> févr. - 28 févr.',
      '1 mars – 10 avril',
    ],
  },
  'challenges/season/dates': {
    en: 'Sept 29 - April 10',
    fr: '29 sept. – 10 avril',
  },
  'challenges/playoffs/dates': {
    en: 'Apr 18',
    fr: '18 avr.',
  },

  'challenges/pasts': {
    en: [
      '<span>Prizing Info</span> Top 5 participants won grand prizes from EA SPORTS.',
      '<span>Prizing Info</span> Top 5 participants won grand prizes from Canadian Tire and Sport Check.',
      '<span>Prizing Info</span> The top 5 participants won prizes from Tim Hortons and the NHL.',
      '<span>Prizing Info</span> The top 5 participants won prizes from Clorox.',
      '<span>Prizing Info</span> The top 5 participants won prizes from Sobeys.',
      '<span>Prizing Info</span> Top 5 participants won grand prizes from Esso.',
      '<span>Prizing Info</span> Top 5 participants won grand prizes from Tim Hortons and FunRideBikes.com!',
    ],
    fr: [
      '<span>Prix</span> Les 5 meilleurs participants ont remporté des prix de EA SPORTS.',
      '<span>Prix</span> Les 5 meilleurs participants ont remporté des prix de Canadian Tire et Sport Check.',
      '<span>Prix</span> Les 5 meilleurs participants ont remporté des prix de Tim Hortons et de la LNH.',
      '<span>Prix</span> Les 5 meilleurs participants ont remporté des prix de Clorox.',
      '<span>Prix</span> Les 5 meilleurs participants ont remporté des prix de IGA.',
      '<span>Prix</span> Les 5 meilleurs participants ont remporté des prix de Esso.',
      '<span>Prix</span> Les 5 meilleurs participants ont remporté des Tim Hortons et de FunRideBikes.com!',
    ],
  },
  'challenges/text': {
    en: 'The top five players at the end of each month have a chance to win a prize in the Monthly Challenge. Check out the prizes below!',
    fr: 'Les cinq participants ayant accumulé le plus de points à la fin de chaque défi mensuel courront la chance de gagner un prix du défi mensuel. Découvrez les prix ci-dessous!',
  },
  'challenges/prizes': {
    en: [
      'One $400 Canadian Tire Gift Card + One $400 Sport Chek Gift Card + One $400 DoorDash Gift Card + $400 Tims Gift Card',
      'One $250 Canadian Tire Gift Card + One $250 Sport Chek Gift Card + One $250 DoorDash Gift Card + $250 Tims Gift Card',
      'One $200 Canadian Tire Gift Card + One $200 Sport Chek Gift Card + One $200 DoorDash Gift Card + $200 Tims Gift Card',
      'One $150 Canadian Tire Gift Card + One $150 Sport Chek Gift Card + One $150 DoorDash Gift Card + $150 Tims Gift Card',
      'One $100 Canadian Tire Gift Card + One $100 Sport Chek Gift Card + One $100 DoorDash Gift Card + $100 Tims Gift Card',
    ],
    fr: [
      'Une carte-cadeau Canadian Tire de 400 $ + une carte-cadeau Sport Chek de 400 $ + une carte-cadeau DoorDash de 400 $ + une carte-cadeau Tim de 400 $',
      'Une carte-cadeau Canadian Tire de 250 $ + une carte-cadeau Sport Chek de 250 $ + une carte-cadeau DoorDash de 250 $ + une carte-cadeau Tim de 250 $',
      'Une carte-cadeau Canadian Tire de 200 $ + une carte-cadeau Sport Chek de 200 $ + une carte-cadeau DoorDash de 200 $ + une carte-cadeau Tim de 200 $',
      'Une carte-cadeau Canadian Tire de 150 $ + une carte-cadeau Sport Chek de 150 $ + une carte-cadeau DoorDash de 150 $ + une carte-cadeau Tim de 150 $',
      'Une carte-cadeau Canadian Tire de 100 $ + une carte-cadeau Sport Chek de 100 $ + une carte-cadeau DoorDash de 100 $ + une carte-cadeau Tim de 100 $',
    ],
  },
  'challenges/future/src': {
    en: 'tnhc_en_white.png',
    fr: 'tnhc_fr_white.png',
  },
  'challenges/future/text': {
    en: '<span>Challenge Awaits</span> Prizing info will be released once this challenge begins.',
    fr: '<span>Le défi vous attend</span> Les informations sur les prix seront publiées une fois ce défi commencé.',
  },
  'challenges/footer/disclaimer': {
    en: 'View terms and conditions (<a target="_parent" href="https://www.timhortons.ca/reglements-dhlt">FR</a> | <a target="_parent" href="https://www.timhortons.ca/tnhc-rules">EN</a>)',
    fr: '<a target="_parent" href="https://www.timhortons.ca/reglements-dhlt">Voir les modalités</a>',
  },
  'challenges/playoffs/prizes': {
    en: [
      'Grand Prize of $5,000',
      '$1,000 Tims Gift Card',
      '$750 Tims Gift Card',
      '$500 Tims Gift Card',
      '$250 Tims Gift Card',
    ],
    fr: [
      'Grand prix de 5 000 $',
      '1 000 $ en Cartes-cadeaux Tim',
      '750 $ en Cartes-cadeaux Tim',
      '500 $ en Cartes-cadeaux Tim',
      '250 $ en Cartes-cadeaux Tim',
    ],
  },
  'challenges/playoffs/heatstreakbanner/title': {
    en: '7-Day Win Streak',
    fr: 'Série de victoires de 7 jours',
  },
  'challenges/playoffs/heatstreakbanner/text': {
    en: 'Guessed correctly for 7 consecutive days? You’ll win a free donut for a week!*',
    fr: 'Vous avez fait les bons choix pendant 7 jours consécutifs? Vous gagnez un beigne gratuit pendant une semaine*!',
  },
  'challenges/nochallenge/title': {
    en: 'Thank you for playing!',
    fr: 'Merci de vous prêter au jeu!',
  },
  'challenges/nochallenge/description': {
    en: 'We hope you enjoyed the Tim Hortons NHL Hockey Challenge<sup>TM</sup>. Check your stats to see how you did!',
    fr: 'Nous espérons que vous avez aimé le Défi de hockey de la LNH<sup>MD</sup> de Tim Hortons®. Consultez vos statistiques pour voir vos performances!',
  },
  'challenges/nochallenge/buttonText': {
    en: 'Check your stats',
    fr: 'Vérifiez vos statistiques',
  },
};

export default strings;
